import type { VenderTranslationEntity } from './VenderTrasnlationEntity'

export class VenderEntity {
  id?: number
  translations?: Array<VenderTranslationEntity> | null
  imageUrl?: string | null
}
 